import { useAiToolkitContext } from '@app/(darkHeader)/ai/_shared/_context/AiToolkitContext';
import { AI_TOOLKIT_CATEGORIES, AiToolkitCategory } from '@app/(darkHeader)/ai/_shared/_context/types';
import { useRouter } from 'next/navigation';
import { type JSX, useCallback } from 'react';

import { ConfirmationModal } from '@videoblocks/design-system';

const getModalContent = (category: AiToolkitCategory): string => {
    switch (category) {
        case AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION:
            return 'Your account does not have enough credits to generate this video. Please contact your Success Team representative to purchase additional credits.';
        case AI_TOOLKIT_CATEGORIES.IMAGE_GENERATION:
            return 'Your account does not have enough credits to generate this image. Please contact your Success Team representative to purchase additional credits.';
        case AI_TOOLKIT_CATEGORIES.VIDEO_EDIT:
            // TODO: Add video edit modal content
            return '';
        case AI_TOOLKIT_CATEGORIES.VOICEOVER:
            return 'Your account does not have enough credits to generate this voiceover. Please contact your Success Team representative to purchase additional credits.';
    }
};

export const EnterpriseInsufficientCreditsModal = (): JSX.Element => {
    const { confirmationModal, dispatchConfirmationModal } = useAiToolkitContext();
    const router = useRouter();

    const { type, category = AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION } = confirmationModal ?? {};
    const isOpen = type === 'entInsufficientCredits' && confirmationModal?.isOpen === true;

    const onClose = useCallback((): void => {
        dispatchConfirmationModal({ type: 'CLOSE_MODAL' });
    }, [dispatchConfirmationModal]);

    const handleContactNow = useCallback((): void => {
        dispatchConfirmationModal({ type: 'CLOSE_MODAL' });
        router.push('/member/support');
    }, [router, dispatchConfirmationModal]);

    return (
        <ConfirmationModal
            isOpen={isOpen}
            title="Out of credits"
            content={getModalContent(category)}
            confirmLabel="Contact Now"
            cancelLabel="Cancel"
            onConfirm={handleContactNow}
            onCancel={onClose}
        />
    );
};
